import React from 'react';
import _ from 'lodash';
import HelloSign from 'hellosign-embedded';
import {
  Flex, Text, Box, ActionNote, Loading,
} from '../components';
import * as S from '../styles';
import FormConsumer from '../collect-info/FormConsumers';
import { Button, SecondaryButton } from '../styles';
import Axios from '../request';
import { toFormData } from '../../../assets/js/utils';
import { skipDomainVerificationHelloSign, helloSignClientId } from '../../../config';
import {
  stateOptions,
  EMPLOYER_STEP as STEPS,
  listADocumentsByCitizenshipStatus,
  listCDocumentsByCitizenshipStatus,
  listBDocuments,
  employeeInfoReviewQuestions,
  employmentDetailsQuestions,
  listAQuestions as listAEmptyQuestions,
  listBAndCQuestions as listBAndCEmptyQuestions,
  step3Questions as step3EmptyQuestions,
} from './data';
import {
  getMasterAssignee,
  isActionMasterAssigneeMatchCompanyStaff,
} from '../App';
import { isActionAssigneeMatchCompanyStaffV2 } from '../../../utils';

export const getSecurePDFLink = (digestKey) => `${APIHOST}/v1/i9_form_submissions/:digest_key/pdf`.replace(':digest_key', digestKey);

function DocumentBox({
  type, selected, onClick, disabled,
}) {
  let imgURL;
  let text;
  let extraText = '';
  switch (type) {
    case 'passport':
      text = 'U.S. Passport';
      imgURL = '/j/images/onboarding/passport.svg';
      break;
    case 'driver_license':
      text = 'Driver’s license and Social Security card';
      imgURL = '/j/images/onboarding/driver-license.svg';
      break;
    case 'others':
      text = 'Other';
      imgURL = '/j/images/onboarding/other-document.svg';
      extraText = 'If you want to submit different documents, you can choose from the full list here.';
      break;
  }
  let borderStyle = '1px solid #DEE1EC';
  let backgroundColor = 'white';
  if (selected) {
    borderStyle = '1px solid #0D8CE6';
    backgroundColor = '#ECF6FD';
  }

  return (
    <Flex
      onClick={!disabled && onClick}
      alignItems="center"
      py="16px"
      px="22px"
      border={borderStyle}
      borderRadius="4px"
      mb={10}
      style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
      backgroundColor={backgroundColor}
    >

      <Flex mr={14} width={50} justifyContent="center" flexShrink={0}>
        <img src={imgURL} />
      </Flex>
      <Flex column>
        <Text>{text}</Text>
        {extraText && <Text color="#999999">{extraText}</Text>}
      </Flex>

    </Flex>
  );
}

class EmployerFillForm extends React.Component {
  constructor(props) {
    super(props);
    const { action: { i9_form_submission: { data = {} } } } = props;

    let currentStep = STEPS.step1;
    if (props.viewResultAsManager) {
      currentStep = STEPS.step4;
    }

    const { processData } = window;
    const i9Module = processData ? processData.employee_onboarding_modules.find((m) => m.module_type === 'i9') : undefined;
    const eVerifyOn = _.get(i9Module, 'config.eVerifyOn', false);

    this.state = {
      data,
      currentStep,
      saveDataError: false,
      signError: false,
      isLoading: false,
      eVerifyOn,

      // step 1 data (Enter personal information)
      pickedGroup: undefined,
      selectedDocuments: [],

      // step 2 data (resident status)
      employeeQuestions: this.injectAnswersToQuestions({ questions: employeeInfoReviewQuestions, data }),
      employmentDetailsQuestions: this.injectAnswersToQuestions({ questions: employmentDetailsQuestions, data }),
      listAQuestions: this.injectAnswersToQuestions({ questions: listAEmptyQuestions, data }),
      listBAndCQuestions: this.injectAnswersToQuestions({ questions: listBAndCEmptyQuestions, data }),

      // step 3 data
      step3Questions: this.injectAnswersToQuestions({ questions: step3EmptyQuestions, data }),

      // step 4 (review)

      // step 5 data (signing)
      signLink: undefined,
    };
    this.step2Form = React.createRef();
    this.step2EmploymentDetailsForm = React.createRef();
    this.step3Form = React.createRef();

    let residentStatusCode = 'citizen';
    if (i9Module) {
      const employeeI9Action = i9Module.actions.find((a) => a.action_type === 'employee_fill_i9_form');
      const employeeI9Submission = employeeI9Action.i9_form_submission;
      residentStatusCode = employeeI9Submission.data.resident_status_code;
    }

    this.listADocuments = listADocumentsByCitizenshipStatus[residentStatusCode];
    this.listCDocuments = listCDocumentsByCitizenshipStatus[residentStatusCode];
    this.listBDocuments = listBDocuments;
  }

  injectAnswersToQuestions({ questions, data }) {
    const { prefilledData = {} } = this.props;
    const validateCodes = stateOptions.map((s) => s.codeValue);
    if (prefilledData.employer_state && validateCodes.indexOf(prefilledData.employer_state) === -1) {
      delete prefilledData.employer_state;
    }
    if (data.employer_state && validateCodes.indexOf(data.employer_state) === -1) {
      delete data.employer_state;
    }
    const newQuestions = questions.map((question) => {
      const value = data[question.id] || prefilledData[question.id] || '';
      // if (!data[question.id] && prefilledData[question.id]) {
      //   question.locked = true;
      // }
      const answer = {
        answer: {
          [question.id]: value,
        },
      };
      return {
        ...question,
        answer,
      };
    });
    return newQuestions;
  }

  initHelloSign() {
    const { signLink } = this.state;
    const containerId = 'iframe-container';

    this.hellosignClient = new HelloSign({
      clientId: helloSignClientId,
    });

    this.hellosignClient.once(HelloSign.events.SIGN, (eventData) => {
      const { event } = eventData;
      if (event === HelloSign.EVENT_SIGNED) {
        // Call API to mark this document as signed
        const { digest_key: digestKey } = this.props.action.i9_form_submission;
        const path = `${APIHOST}/v1/i9_form_submissions/:digest_key/signed`.replace(
          ':digest_key',
          digestKey,
        );
        this.setState({ isLoading: true });
        Axios.post(path, { sign_url: signLink })
          .then(() => {
            this.props.onSignedSuccess();
          })
          .catch((error) => {
            let signError = 'Something wrong with the signing.';
            if (error && error.response && error.response.data) {
              const { message } = error.response.data;
              if (message) {
                signError = message;
              }
            }
            this.setState({ signError });
          }).finally(() => {
            this.setState({ isLoading: false });
          });
      }
    });

    const options = {
      skipDomainVerification: skipDomainVerificationHelloSign,
      container: document.getElementById(containerId),
    };

    this.hellosignClient.open(signLink, options);
  }

  componentWillUnmount() {
    this.hellosignClient && this.hellosignClient.close();
  }

  handleSelectDocumentFromListA(documentTitle, documentCode) {
    const data = {
      ...this.state.data,
      list_a_document_title_1: documentTitle,
      list_a_document_code: documentCode,
    };
    let updatedListAQuestions = this.injectAnswersToQuestions({ questions: listAEmptyQuestions, data });
    if (documentTitle !== 'Foreign passport with Arrival/Departure Record (Form I-94)'
      && documentTitle !== 'Foreign passport with temporary I-551 stamp or printed notation on a MRIV') {
      updatedListAQuestions = _.reject(updatedListAQuestions, (el) => el.id === 'country_of_issuance');
    }
    if (documentTitle !== 'Foreign passport with Arrival/Departure Record (Form I-94)') {
      updatedListAQuestions = _.reject(updatedListAQuestions, (el) => el.id === 'i94_number');
    }
    if (documentCode === 'FORM_I551') {
      updatedListAQuestions = _.reject(updatedListAQuestions, (el) => el.id === 'list_a_document_number_1');
    } else {
      updatedListAQuestions = _.reject(updatedListAQuestions, (el) => el.id === 'i551_number');
    }
    this.setState({
      selectedDocuments: [documentTitle],
      data,
      listAQuestions: updatedListAQuestions,
    });
  }

  handleSelectDocumentFromListB(documentTitle, documentCode) {
    const driverLicenseTitle = 'Driver\'s license issued by state/territory';
    const { selectedDocuments } = this.state;
    let documents = selectedDocuments.filter((item) => {
      if (this.listADocuments.map((d) => d.abbr).indexOf(item) !== -1) return false;
      if (this.listBDocuments.map((d) => d.abbr).indexOf(item) !== -1) return false;
      return true;
    });
    documents = [...documents, documentTitle];
    const data = {
      ...this.state.data,
      list_b_document_title_1: documentTitle,
      list_b_document_code: documentCode,
    };
    let updatedQuestions = this.injectAnswersToQuestions({ questions: listBAndCEmptyQuestions, data });
    if (driverLicenseTitle !== documentTitle) {
      updatedQuestions = _.reject(updatedQuestions, (el) => el.id === 'list_b_us_state_code_1');
    }
    this.setState({
      selectedDocuments: documents,
      data,
      listBAndCQuestions: updatedQuestions,
    });
  }

  handleSelectDocumentFromListC(documentTitle, documentCode) {
    const { selectedDocuments } = this.state;
    let documents = selectedDocuments.filter((item) => {
      if (this.listADocuments.map((d) => d.abbr).indexOf(item) !== -1) return false;
      if (this.listCDocuments.map((d) => d.abbr).indexOf(item) !== -1) return false;
      return true;
    });
    documents = [...documents, documentTitle];
    const data = {
      ...this.state.data,
      list_c_document_title_1: documentTitle,
      list_c_document_code: documentCode,
    };
    const updatedQuestions = this.injectAnswersToQuestions({ questions: listBAndCEmptyQuestions, data });
    this.setState({
      selectedDocuments: documents,
      data,
      listBAndCQuestions: updatedQuestions,
    }, () => {
    });
  }

  saveFormData(data, successCallback) {
    const { digest_key: digestKey } = this.props.action.i9_form_submission;
    this.setState({ isSubmitting: true, saveDataError: false });
    const path = `${APIHOST}/v1/i9_form_submissions/${digestKey}`;
    Axios.put(path, toFormData({ data }))
      .then((responseData) => {
        this.setState({ isSubmitting: false });
        successCallback(responseData);
      })
      .catch((error) => {
        let saveDataError = 'Something went wrong while saving data.';
        if (error && error.response && error.response.data) {
          const { error_code: errorCode, message } = error.response.data;
          if (message) {
            saveDataError = message;
          }
          if (errorCode === 43001 || errorCode === 43002) {
            // Need to refresh the side bar action status
            if (this.props.refreshProgressDataFn) this.props.refreshProgressDataFn();
          }
        }
        this.setState({ isSubmitting: false, saveDataError });
      });
  }

  renderStep1() {
    const { data } = this.state;
    const { pickedGroup, selectedDocuments, isSubmitting } = this.state;
    const { action, companyStaff } = this.props;
    const { status, assignees } = action;
    let disabledText = '';
    let waitForEmployee = false;
    let hideButton = false;
    const disableNext = (() => {
      if (this.props.previewMode) {
        disabledText = 'You cannot complete this step in Preview Mode.';
        return true;
      }

      const masterAssignee = getMasterAssignee(action.assignees);
      if (masterAssignee && masterAssignee.company_staff.id !== companyStaff.id && status === 'not_started') {
        disabledText = `This action should be done by ${masterAssignee && masterAssignee.company_staff.name}`;
        return true;
      }

      if (!isActionAssigneeMatchCompanyStaffV2(assignees, companyStaff)) {
        const assigneeNames = (() => {
          if (!assignees || !assignees.length === 0 || !assignees[0]) return null;
          return assignees.map((item) => item.company_staff && item.company_staff.name);
        })();
        disabledText = `This action should be done by ${assigneeNames.join(' or ')}`;
        return true;
      }

      if (!data.employee_citizenship) {
        waitForEmployee = true;
        disabledText = 'Employee needs to finish the form first.';
        return true;
      }
      if (!pickedGroup) return true;
      if (selectedDocuments.length === 0) return true;
      // Check document requirements
      // 1. one document from list a
      // 2. or two documents from list b and list c
      const fromA = !!selectedDocuments.find((item) => this.listADocuments.map((d) => d.abbr).indexOf(item) !== -1);
      const fromB = !!selectedDocuments.find((item) => this.listBDocuments.map((d) => d.abbr).indexOf(item) !== -1);
      const fromC = !!selectedDocuments.find((item) => this.listCDocuments.map((d) => d.abbr).indexOf(item) !== -1);
      if (!fromA && !(fromB && fromC)) return true;

      return false;
    })();

    if (!isActionMasterAssigneeMatchCompanyStaff(action.assignees, companyStaff) && status === 'in_progress') {
      hideButton = true;
    }

    return (
      <Flex column>
        <Text fontSize={11} semibold color="#0D8CE6">
          Step 1/5
        </Text>
        <Text fontSize="22px" bold>
          Examine documents
        </Text>
        <Text fontSize="12px">
          To complete their Form I-9, your new employee needs to present unexpired documents that show their identity and authorization to work in the United States.
        </Text>
        <Flex column mt={44}>
          <S.QuestionLabel isRequired>Which documents did your employee bring?</S.QuestionLabel>
          <Flex column mt={20}>
            <DocumentBox
              disabled={waitForEmployee}
              selected={pickedGroup === 'passport'}
              type="passport"
              onClick={() => {
                this.setState({
                  pickedGroup: 'passport',
                }, () => {
                  const documentAbbr = 'U.S. Passport or Passport Card';
                  const documentCode = 'US_PASSPORT';
                  this.handleSelectDocumentFromListA(documentAbbr, documentCode);
                });
              }}
            />
            <DocumentBox
              disabled={waitForEmployee}
              selected={pickedGroup === 'driver_license'}
              type="driver_license"
              onClick={() => {
                const driverLicenseTitle = "Driver's license issued by state/territory";
                const socialSecurityCardTitle = 'Social Security Card';
                this.setState({
                  pickedGroup: 'driver_license',
                }, () => {
                  this.handleSelectDocumentFromListB(driverLicenseTitle, 'DRIVERS_LICENSE');
                  setTimeout(() => {
                    this.handleSelectDocumentFromListC(socialSecurityCardTitle, 'SOCIAL_SECURITY_CARD');
                  }, 100);
                });
              }}
            />
            <DocumentBox
              disabled={waitForEmployee}
              selected={pickedGroup === 'others'}
              type="others"
              onClick={() => {
                const data = {
                  ...this.state.data,
                  list_a_document_title_1: undefined,
                  list_a_document_code: undefined,
                  list_b_document_title_1: undefined,
                  list_b_document_code: undefined,
                  list_c_document_title_1: undefined,
                  list_c_document_code: undefined,
                };
                this.setState({
                  pickedGroup: 'others',
                  selectedDocuments: [],
                  data,
                });
              }}
            />
          </Flex>

          {pickedGroup === 'others' && (
            <Flex column mt={30}>
              <S.QuestionLabel>Documents that establish both identity and employment authorization:</S.QuestionLabel>
              <Flex column mt={15}>
                {this.listADocuments.map((document) => {
                  const { name, code, abbr } = document;
                  return (
                    <label key={`a-${code}`}>
                      <Flex alignItems="flex-start">
                        <S.Input
                          type="radio"
                          checked={selectedDocuments.indexOf(abbr) !== -1}
                          onChange={(e) => {
                            if (e.target.checked) {
                              this.handleSelectDocumentFromListA(abbr, code);
                            }
                          }}
                        />
                        <Box ml="10px" />
                        <Box mt="4px">
                          {name}
                        </Box>
                      </Flex>
                    </label>
                  );
                })}
              </Flex>

              <Flex alignItems="center" my={25}>
                <Text semibold color="#999999" mr={10} fontSize="13px">OR</Text>
                <Box flexGrow="1" style={{ backgroundColor: '#E3E4E6', height: '1px' }} />
              </Flex>

              <S.QuestionLabel>Documents that establish identity:</S.QuestionLabel>
              <Flex column mt={15}>
                {this.listBDocuments.map((document) => {
                  const { name, code, abbr } = document;
                  return (
                    <label key={`b-${code}`}>
                      <Flex alignItems="flex-start">
                        <S.Input
                          type="radio"
                          checked={selectedDocuments.indexOf(abbr) !== -1}
                          onChange={(e) => {
                            if (e.target.checked) {
                              this.handleSelectDocumentFromListB(abbr, code);
                            }
                          }}
                        />
                        <Box ml="10px" />
                        <Box mt="4px">
                          {name}
                        </Box>
                      </Flex>
                    </label>
                  );
                })}
              </Flex>

              <Flex alignItems="center" my={25}>
                <Text semibold color="#999999" mr={10} fontSize="13px">AND</Text>
                <Box flexGrow="1" style={{ backgroundColor: '#E3E4E6', height: '1px' }} />
              </Flex>

              <S.QuestionLabel>Documents that establish employment authorization:</S.QuestionLabel>
              <Flex column mt={15}>
                {this.listCDocuments.map((document) => {
                  const { name, code, abbr } = document;
                  return (
                    <label key={`c-${code}`}>
                      <Flex alignItems="flex-start">
                        <S.Input
                          type="radio"
                          checked={selectedDocuments.indexOf(abbr) !== -1}
                          onChange={(e) => {
                            if (e.target.checked) {
                              this.handleSelectDocumentFromListC(abbr, code);
                            }
                          }}
                        />
                        <Box ml="10px" />
                        <Box mt="4px">
                          {name}
                        </Box>
                      </Flex>
                    </label>
                  );
                })}
              </Flex>

            </Flex>
          )}

        </Flex>
        {
          !hideButton && (
            <Flex mt={40} column>
              <Button
                disabled={disableNext}
                onClick={() => {
                  this.setState({ currentStep: STEPS.step2 });
                }}
                loading={isSubmitting}
              >
                Next
              </Button>
              <Flex justifyContent="flex-end">
                {disabledText && <ActionNote text={disabledText} />}
              </Flex>
            </Flex>
          )
        }
      </Flex>
    );
  }

  renderStep2Form(isReviewStep) {
    const {
      employeeQuestions,
      selectedDocuments,
      listAQuestions,
      listBAndCQuestions,
      employmentDetailsQuestions,
    } = this.state;

    const fromA = !!selectedDocuments.find((item) => this.listADocuments.map((d) => d.abbr).indexOf(item) !== -1);
    const fromB = !!selectedDocuments.find((item) => this.listBDocuments.map((d) => d.abbr).indexOf(item) !== -1);
    const fromC = !!selectedDocuments.find((item) => this.listCDocuments.map((d) => d.abbr).indexOf(item) !== -1);

    return (
      <Flex column>
        {/* Employee info review */}
        <FormConsumer
          questions={employeeQuestions}
          viewResultAsManager
          {...{ viewResultAsManager: true, reviewActions: [] }}
        />

        <Text semibold fontSize="16px" mt={27} mb={25}>Employment details</Text>
        {/* Employee info review */}
        <FormConsumer
          questions={employmentDetailsQuestions}
          {...(isReviewStep && { viewResultAsManager: true, reviewActions: [] })}
          onQuestionChange={({ question, value }) => {
            const questions = employmentDetailsQuestions.map((q) => {
              if (q.id !== question.id) return q;
              const answer = {
                ...q.anser,
                answer: {
                  ...q.answer.answer,
                  [q.id]: value,
                },
              };
              const updatedQuestion = { ...q, answer };
              return updatedQuestion;
            });
            this.setState({ employmentDetailsQuestions: questions });
          }}
          ref={this.step2EmploymentDetailsForm}
        />

        {/* Employer fill form */}
        <Text fontSize="13px">Please use the submitted documents to fill out the following information</Text>
        <Text semibold fontSize="16px" mt={27} mb={25}>Documents details</Text>

        {/* list a questions */}
        {fromA && (
        <FormConsumer
          {...(isReviewStep && { viewResultAsManager: true, reviewActions: [] })}
          questions={listAQuestions}
          onQuestionChange={({ question, value }) => {
            const questions = listAQuestions.map((q) => {
              if (q.id !== question.id) return q;
              const answer = {
                ...q.anser,
                answer: {
                  ...q.answer.answer,
                  [q.id]: value,
                },
              };
              const updatedQuestion = { ...q, answer };
              return updatedQuestion;
            });
            this.setState({ listAQuestions: questions });
          }}
          ref={this.step2Form}
        />
        )}
        {fromB && fromC && (
        <FormConsumer
          {...(isReviewStep && { viewResultAsManager: true, reviewActions: [] })}
          questions={listBAndCQuestions}
          onQuestionChange={({ question, value }) => {
            const questions = listBAndCQuestions.map((q) => {
              if (q.id !== question.id) return q;
              const answer = {
                ...q.anser,
                answer: {
                  ...q.answer.answer,
                  [q.id]: value,
                },
              };
              const updatedQuestion = { ...q, answer };
              return updatedQuestion;
            });
            this.setState({ listBAndCQuestions: questions });
          }}
          ref={this.step2Form}
        />
        )}

      </Flex>
    );
  }

  renderStep2() {
    const {
      selectedDocuments,
      listAQuestions,
      listBAndCQuestions,
      employmentDetailsQuestions,
    } = this.state;

    let questions = [];
    const fromA = !!selectedDocuments.find((item) => this.listADocuments.map((d) => d.abbr).indexOf(item) !== -1);
    const fromB = !!selectedDocuments.find((item) => this.listBDocuments.map((d) => d.abbr).indexOf(item) !== -1);
    const fromC = !!selectedDocuments.find((item) => this.listCDocuments.map((d) => d.abbr).indexOf(item) !== -1);
    let documentCodeData;
    if (fromA) {
      questions = listAQuestions;
      documentCodeData = {
        list_a_document_code: this.state.data.list_a_document_code,
      };
    }
    if (fromB && fromC) {
      questions = listBAndCQuestions;
      documentCodeData = {
        list_b_document_code: this.state.data.list_b_document_code,
        list_c_document_code: this.state.data.list_c_document_code,
      };
    }

    return (
      <Flex column>
        <Text fontSize={11} semibold color="#0D8CE6">
          Step 2/5
        </Text>
        <Text fontSize="22px" bold>
          Examine documents
        </Text>
        <Text fontSize="12px">
          To complete their Form I-9, your new employee needs to present unexpired documents that show their identity and authorization to work in the United States.
        </Text>
        <Text fontSize="13px" mt={12}>The employee entered the following information in Section 1: </Text>
        <Flex column mt={44}>
          {this.renderStep2Form()}
        </Flex>
        <Flex>
          <SecondaryButton
            onClick={() => {
              this.setState({ currentStep: STEPS.step1, saveDataError: false });
            }}
          >
            Back
          </SecondaryButton>
          <Flex flex={1} column ml={2}>
            <Button
              onClick={() => {
                if (this.step2Form && this.step2Form.current) {
                  this.step2Form.current.validate((error) => {
                    if (error) return;
                    // Because the API is for incrementally saving data, and some data
                    // are mutually exclusive, so we need have a base empty value for
                    // those fields
                    const emptyData = {
                      list_a_document_title_1: '',
                      list_a_document_code: '',
                      list_a_document_number_1: '',
                      list_a_issuing_authority_1: '',
                      i551_number: '',
                      list_a_expiration_date_1: '',
                      list_b_document_title_1: '',
                      list_b_document_code: '',
                      list_b_document_number_1: '',
                      list_b_issuing_authority_1: '',
                      list_b_expiration_date_1: '',
                      list_c_document_title_1: '',
                      list_c_document_code: '',
                      list_c_document_number_1: '',
                      list_c_issuing_authority_1: '',
                      list_c_expiration_date_1: '',
                    };

                    if (this.step2EmploymentDetailsForm && this.step2EmploymentDetailsForm.current) {
                      this.step2EmploymentDetailsForm.current.validate((error) => {
                        if (error) return;

                        const step2Data = questions.concat(employmentDetailsQuestions).reduce((acc, question) => ({ ...acc, ...question.answer.answer }), documentCodeData);
                        this.saveFormData({ ...emptyData, ...step2Data }, () => {
                          this.setState({ currentStep: STEPS.step3 });
                        });
                      });
                    }
                  });
                }
              }}
              loading={this.state.isSubmitting}
            >
              Next
            </Button>
          </Flex>
        </Flex>
      </Flex>
    );
  }

  renderStep3Form(isReviewStep) {
    let {
      step3Questions,
      eVerifyOn,
    } = this.state;

    if (!eVerifyOn) {
      step3Questions = _.reject(step3Questions, (el) => el.id === 'e_verify_case_creator_name' || el.id === 'e_verify_case_creator_phone' || el.id === 'e_verify_case_creator_email_address');
    }

    return (
      <Flex column>
        <FormConsumer
          {...(isReviewStep && { viewResultAsManager: true, reviewActions: [] })}
          questions={step3Questions}
          onQuestionChange={({ question, value }) => {
            const questions = step3Questions.map((q) => {
              if (q.id !== question.id) return q;
              const answer = {
                ...q.anser,
                answer: {
                  ...q.answer.answer,
                  [q.id]: value,
                },
              };
              const updatedQuestion = { ...q, answer };
              return updatedQuestion;
            });
            this.setState({ step3Questions: questions });
          }}
          ref={this.step3Form}
        />
      </Flex>
    );
  }

  renderStep3() {
    const {
      step3Questions,
    } = this.state;

    return (
      <Flex column>
        <Text fontSize={11} semibold color="#0D8CE6">
          Step 3/5
        </Text>
        <Text fontSize="22px" bold>
          Employer information
        </Text>
        <Flex column mt={44}>
          {this.renderStep3Form()}
        </Flex>
        <Flex>
          <SecondaryButton
            onClick={() => {
              this.setState({ currentStep: STEPS.step2, saveDataError: false });
            }}
          >
            Back
          </SecondaryButton>
          <Flex flex={1} column ml={2}>
            <Button
              onClick={() => {
                if (this.step3Form && this.step3Form.current) {
                  this.step3Form.current.validate((error) => {
                    if (error) return;
                    const data = step3Questions.reduce((acc, question) => ({ ...acc, ...question.answer.answer }), {});
                    this.saveFormData(data, () => {
                      this.setState({ currentStep: STEPS.step4 });
                    });
                  });
                }
              }}
              loading={this.state.isSubmitting}
            >
              Next
            </Button>
          </Flex>
        </Flex>
      </Flex>
    );
  }

  renderStep4() {
    const { viewResultAsManager } = this.props;
    let pdfURL;
    if (viewResultAsManager) {
      const { digest_key: digestKey } = this.props.action.i9_form_submission;
      pdfURL = getSecurePDFLink(digestKey);
    }
    return (
      <Flex column>
        {
          !viewResultAsManager && (
            <Text fontSize={11} semibold color="#0D8CE6">
              Step 4/5
            </Text>
          )
        }
        <Text fontSize="22px" bold>
          Review
        </Text>
        <Flex column mt={33}>
          <Text fontSize="18px" bold>
            Employee information
          </Text>
          <Box mt={16} />
          {this.renderStep2Form(true)}

          {/* step 2 result */}
          <Flex mt={44} column>
            <Text fontSize="18px" bold>
              Employer information
            </Text>
            <Box mt={16} />
            {this.renderStep3Form(true)}
          </Flex>
        </Flex>
        {this.props.viewResultAsManager
          && this.props.companyStaff.pii_permission === 'full_access' && (
            <Flex column>
              <Flex alignItems="center">
                <Text mr={16}>Download signed documents</Text>
                <a href={pdfURL} target="_blank" rel="noopener noreferrer">
                  <img src="/j/images/onboarding/download.svg" />
                </a>
              </Flex>
            </Flex>
        )}
        <Flex mt={50}>
          <SecondaryButton
            disabled={this.props.viewResultAsManager}
            onClick={() => {
              this.setState({ currentStep: STEPS.step3, saveDataError: false });
            }}
          >
            Back
          </SecondaryButton>
          <Flex flex={1} column ml={2}>
            <Button
              disabled={this.props.viewResultAsManager}
              onClick={() => {
                const { digest_key: digestKey } = this.props.action.i9_form_submission;
                const path = `${APIHOST}/v1/i9_form_submissions/${digestKey}/sign`;
                this.setState({ isSubmitting: true, saveDataError: false });
                Axios.post(path, {})
                  .then((responseData) => {
                    this.setState({ isSubmitting: false });
                    const { sign_url: signLink } = responseData.data;
                    this.setState({ signLink, currentStep: STEPS.step5 }, () => {
                      this.initHelloSign();
                    });
                  })
                  .catch((error) => {
                    let saveDataError = 'Something went wrong while saving data.';
                    if (error && error.response && error.response.data) {
                      const { error_code: errorCode, message } = error.response.data;
                      if (message) {
                        saveDataError = message;
                      }
                      if (errorCode === 43001 || errorCode === 43002) {
                        // Need to refresh the side bar action status
                        if (this.props.refreshProgressDataFn) this.props.refreshProgressDataFn();
                      }
                    }
                    this.setState({ isSubmitting: false, saveDataError });
                  });
              }}
              loading={this.state.isSubmitting}
            >
              Finalize and Sign
            </Button>
          </Flex>
        </Flex>
        <Flex justifyContent="flex-end">
          {this.props.viewResultAsManager && (
            <ActionNote text="This step has already been completed." />
          )}
        </Flex>
      </Flex>
    );
  }

  renderStep5() {
    const { signError, isLoading } = this.state;
    return (
      <Flex column>
        <Text fontSize="22px" bold>
          Sign Form I-9
        </Text>
        {
          isLoading && (
            <Flex>
              <Loading className="spinner spinner-blue" />
            </Flex>
          )
        }
        <Flex column mt={44} mx="-100px">
          <div id="iframe-container" style={{ height: '640px' }} />
        </Flex>
        {signError && <Text color="red">{signError}</Text>}
      </Flex>
    );
  }

  render() {
    const { currentStep, saveDataError } = this.state;
    return (
      <Flex column>
        <Flex column style={{ width: '310px', margin: 'auto' }}>
          {currentStep === STEPS.step1 && this.renderStep1()}
          {currentStep === STEPS.step2 && this.renderStep2()}
          {currentStep === STEPS.step3 && this.renderStep3()}
          {currentStep === STEPS.step4 && this.renderStep4()}
          {saveDataError && (
          <Flex justifyContent="flex-end" mt={1}>
            <Text color="red">{saveDataError}</Text>
          </Flex>
          )}
        </Flex>
        <Flex column style={{ width: '50%', margin: 'auto', maxWidth: 800 }}>
          {currentStep === STEPS.step5 && this.renderStep5()}
        </Flex>
      </Flex>
    );
  }
}

export default EmployerFillForm;
